import { useState } from "react";
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputBase from '@mui/material/InputBase';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from 'assets/jss/Report/FilterDaysStyles';
import { makeStyles } from "@mui/styles";
import Backdrop from "@mui/material/Backdrop";
import {digitsEnToFa} from "persian-tools2";

const useStyles = makeStyles(styles);
const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        // marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
        zIndex: '2',
        background: '#F5F5F5',
        border: '1px solid #FFFFFF',
        marginRight: '50px',
        borderRadius: '98px',
        width: '125px !important',
        margin: '0 auto 0',
        boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1)',
        fontFamily: 'kalameh',
        fontWeight: '700',
        fontSize: '12px',
        textAlign: 'center',
        color: "#753CBE",
        paddingRight: '10px !important',


        '&:focus': {
            background: '#F4F4F4',
            border: '1px solid #FFFFFF',
            marginRight: '50px',
            borderRadius: '98px',
            // width: '240px',
            margin: '0rem auto',
            boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1)'
        },
    },
}));

export default function FilterComponent(props) {
    const { onChaneHandler } = props;
    const [filterChoice, setFilterChoice] = useState('14');
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const daysChoices = [7, 14, 30, 90, 365];
    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };
    const handleChange = (event) => {
        onChaneHandler(event.target.value);
        setFilterChoice(event.target.value);
    };
    const MyIcon = (props) => {
        const { style, ...otherProps } = props;
        const colorStyle = {
            color: '#707070',
            zIndex: '3',
            marginRight: "8px"
        };
        const styles = { ...style, ...colorStyle };
        return <ExpandMoreIcon {...otherProps} style={styles} />;
    };
    return (
        <>
            <Backdrop
                sx={{
                    color: '#ffffff',
                    zIndex: '10',
                    background: 'rgba(216, 216, 216, 0.37);',
                }}
                open={open}
                onClick={handleClose}
            />
            <FormControl sx={{ m: 1 }} variant="standard">
                <Select
                    onOpen={handleToggle}
                    onClose={handleToggle}
                    id="demo-customized-select-native"
                    value={filterChoice}
                    IconComponent={MyIcon}
                    classes={{
                        select: `${classes.selectStyle}`
                    }}
                    onChange={handleChange}
                    input={<BootstrapInput />}
                    MenuProps={{ style: { marginLeft: '5px', marginTop: '10px' }, classes: { paper: classes.select } }}
                >
                    {daysChoices.map(choice => {
                        return (
                            <MenuItem value={choice} classes={{ selected: classes.ItemSelected }}>
                                {choice === 365 ?
                                    <div>
                                        <div className={classes.numberWeight}>یک سال </div>
                                        {' '}پیش
                                    </div>
                                    :
                                    <div>
                                        <div className={`${classes.numberWeight} ${{ selected: classes.numberWeight }}`}>
                                            {digitsEnToFa(choice)}
                                        </div>
                                        روز پیش
                                    </div>
                                }
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </>
    );
}